import { Col, Empty, Row } from "antd";
import { useListHackathon } from "api/hackathon";
import { GradientButton } from "components/GradientButton";
import { routesEnum } from "pages/Routes";
import React, { FC, useState } from "react";
import { Link } from "react-router-dom";
import ExploreTabs from "./components/ExploreTabs";
import HackathonCard from "./components/HackathonCard";
import styles from "./styles.module.css";

const Explore: FC = () => {
  const [tab, setTab] = useState<"all" | "Upcoming" | "open" | "ended">("all");

  const { data: hackathon } = useListHackathon({
    search: "",
    host: "",
    eligibility: false,
    lengths: [],
    themeTags: [],
    status: tab === "all" ? [] : [tab],
    order_by: "relevant",
    page: 0,
    pageSize: 3,
    isHide: false,
  });

  return (
    <section className={styles.root}>
      <div className="container-lg">
        <Row justify="space-between">
          <h1 className={styles.headline}>Explore Hackathons</h1>
          <ExploreTabs tab={tab} setTab={setTab} />
        </Row>

        {(hackathon?.pagedResult.totalItems === 0 || !hackathon) && (
          <Empty description="Exciting Hackathons Coming Soon, Stay Tuned" />
        )}
        <Row gutter={[30, 24]}>
          {hackathon?.pagedResult.items.map((x) => (
            <Col key={x._id} xs={24} md={12} lg={8}>
              <HackathonCard data={x} />
            </Col>
          ))}
        </Row>

        <div className={styles.buttonWrap}>
          <Link to={routesEnum.home}>
            <GradientButton className="w-100" size="large">
              Explore More
            </GradientButton>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Explore;
